import { render, staticRenderFns } from "./BoardGovernanceAndSupport.vue?vue&type=template&id=38507c70&scoped=true&"
import script from "./BoardGovernanceAndSupport.vue?vue&type=script&lang=js&"
export * from "./BoardGovernanceAndSupport.vue?vue&type=script&lang=js&"
import style0 from "./BoardGovernanceAndSupport.vue?vue&type=style&index=0&id=38507c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38507c70",
  null
  
)

export default component.exports